import Vue from 'vue'
import { addDays } from 'date-fns'

function updateLineInArray(array, line, update) {
  // We must replace whole object if we want keep reactivity and cause re-render
  const index = array.findIndex(arrayLine => arrayLine.id === line.id);
  if (index !== -1) {
    array.splice(index, 1, {
      ...array[index],
      ...update
    })
  }
}

function mapHistoricLineIntoOrderLine(historicLine, currencyRatio) {
  let finalPrice = (Number(historicLine.product[0].price) / currencyRatio).toFixed(2);
  let finalLastPrice = historicLine.product[0].lastPrice && (Number(historicLine.product[0].lastPrice) / currencyRatio).toFixed(2);
  let productObject = {
    ...historicLine.product[0],
    price: finalPrice,
    lastPrice : finalLastPrice,
  }
  return {
    ...historicLine,
    product: productObject,
    localization: historicLine.location,
    option: 1,
    discount: Number(historicLine.discount),
    deliveryDate: new Date(productObject.deliveryDate),
    basePrice: Number(historicLine.product[0].price),
    quantity: Number(historicLine.quantity)
  }
}

export function calculateLinePrice(line) {
  let price =  line.product.price;
  return price * line.quantity
}
export function calculateOptionPrice(price, option) {
  return option === 2 ? (price * 1.3).toFixed(2) : price
}
export function calculateDiscount(price, discount, line) {
  if (line.option === 2) {
    return ((price * 1.3) - (price * (discount *0.01))).toFixed(2);
  }
  return (price - (price * discount * 0.01)).toFixed(2);
}

export default {
  namespaced: true,
  state: {
    order: {
      lines: [],
      customer: {},
      type: "service",
      currency: "PLN",
      language: "pl",
      status: "progress",
      shipping: {},
      shippingValue: '',
      payment: '',
      comment: '',
      proposalTime:''
    },
  },
  getters: {
    itemCount: state => {
      return (state.order.lines.length > 0) ?  state.order.lines.length : 0;
      // return  state.order.lines.reduce((total, line) => total + line.quantity, 0);
    },

    totalPrice: state =>{
      let summary = state.order.lines.reduce(
          (total, line) => total + calculateLinePrice(line),
          0,
          state.order.shippingValue
      )
      return summary;
    },
    transport: state => state.order.shippingValue,
    currentCustomer: state => state.order.customer,
    currentShipping: state => state.order.shipping
  },
  mutations: {
    setLanguage(state, language){
      state.order.language = language;
    },
    setSearchTerm(state, term) {
      state.searchTerm = term;
      state.currentPage = 1;
    },
    selectOrderType(state, type) {
      state.order.type = type;
    },
    selectCustomer(state, currentShipping) {
      state.order.customer = currentShipping;
      Vue.notify({
        group: 'success',
        title: 'Kontrahent wybrany',
        text: currentShipping.company
      });
    },
    addHistoricOrder(state, {orderData, currencyRatio}) {
      Vue.set(state.order, 'lines', orderData.products.map(line => mapHistoricLineIntoOrderLine(line, currencyRatio)))
    },
    addProduct(state, {product,  currencyRatio}) {
      let findProduct = state.order.lines.find(p => p.product.id === product.id);
      if(findProduct){
        findProduct.quantity++;
      } else {
        let calculatedPrice = parseInt(product.calculatedPrice) ? product.calculatedPrice : product.price;
        state.order.lines.push({
          id: Date.now(),
          product: {
            ...product,
            price: (calculatedPrice / currencyRatio).toFixed(2),
            name: (state.order.currency === "PLN") ? product.name : product.descriptionEn,
          },
          basePrice: product.price,
          plnPrice: product.price,
          quantity: product.quantity || 1,
        });
      }
    },
    changeQuantity(state, update) {
      updateLineInArray(state.order.lines, update.line, {
        quantity: update.change
      })
    },
    changeDeliveryDay(state, update) {
      updateLineInArray(state.order.lines, update.line, {
        deliveryDate: update.change
      })
    },
    changeDiscount(state, update) {
      const calculatedValue = calculateDiscount(
        update.ratio ? update.line.basePrice / update.ratio : update.line.basePrice,
        update.change,
        update.line
      )
      updateLineInArray(state.order.lines, update.line, {
        discount: update.change,
        product: {
          ...update.line.product,
          price: calculatedValue
        },
      })
      updateLineInArray(state.order.lines, update.line, {
        plnPrice: calculatedValue * (update.ratio || 1),
      })
    },
    changeOption(state, update) {
      const calculatedValue = calculateOptionPrice(
        update.ratio ? update.line.basePrice / update.ratio : update.line.basePrice,
        update.change
      )
      updateLineInArray(state.order.lines, update.line, {
        discount: 0,
        option: update.change,
        product: {
          ...update.line.product,
          price: calculatedValue
        }
      })
      updateLineInArray(state.order.lines, update.line, {
        plnPrice: calculatedValue * (update.ratio || 1),
      })
    },
    changeComment(state, update) {
      updateLineInArray(state.order.lines, update.line, {
        comment: update.change
      })
    },
    changeDescription(state, update) {
      if (update.change.lang === 'pl') {
        updateLineInArray(state.order.lines, update.line, {
          product: {
            ...update.line.product,
            name: update.change.value
          }
        })
      } else {
        updateLineInArray(state.order.lines, update.line, {
          product: {
            ...update.line.product,
            descriptionEn: update.change.value
          }
        })
      }
    },
    changeLocalization (state, update) {
      updateLineInArray(state.order.lines, update.line, {
        localization: update.change
      })
    },
    changePrice(state, {
      change,
      ratio,
      line,
      leaveDiscount = false,
    }) {
      updateLineInArray(state.order.lines, line, {
        discount: leaveDiscount ? line.discount : 0,
        product: {
          ...line.product,
          price: change,
        }
      })
      if (ratio) {
        updateLineInArray(state.order.lines, line, {
          plnPrice: change * ratio,
        })
      }
    },
    removeProduct(state, lineToRemove) {
      let index = state.order.lines.findIndex(line => line === lineToRemove);
      if (index > -1) {
        state.order.lines.splice(index, 1);
      }
    },
    setCleanCart(state){
      state.order.customer = {};
      state.order.shipping = {};
    },
    setCartData(state, data) {
      state.order.lines = data;
    },
    setCustomerData(state, data) {
      state.order.customer = data;
    },
    clearPages(state) {
      state.pages.splice(0, state.pages.length);
    },
    setPayment(state, value) {
      state.order.payment = value;
    },
    setShipping(state, value) {
      state.order.shipping = value;
    },
    setShippingValue(state,value){
      state.order.shippingValue = value;
    },
    setProposalTime(state,value){
      state.order.proposalTime = value;
    },
    setComment(state, value) {
      state.order.comment = value;
    },
  },
  actions: {
    backCustomer(context) {
      return context.rootState.cart.order.customer.customer.customerId;
    },
    checkCustomerExist(context){
      return true;
      // if(!context.rootState.cart.order.customer.customer ) {
      //   Vue.notify({
      //     group: 'error',
      //     type: 'error',
      //     title: 'Wybierz kontrahenta',
      //     text: 'Musisz wybrać kontrahenta przed dodaniem dokumentu'
      //   });
      // }
    },
    addProduct(context, product) {
      context.commit('addProduct', {
        product,
        localization: context.rootState.auth.user.localization,
        currencyRatio: context.rootState.currency.ratio,
      })
    },
    async getPage(context, getPageCount = 1) {
    },
    reorder (context, orderData) {
        context.commit('addHistoricOrder', {
          orderData,
          currencyRatio: context.rootState.currency.ratio,
        })
    },
    loadCartData(context) {
      let data = localStorage.getItem("cart");
      if (data !== "undefined" && data !== null) {
        context.commit("setCartData", JSON.parse(data));
      }
    },
    storeCartData(context) {
      localStorage.setItem("cart", JSON.stringify(context.state.order.lines));
      localStorage.setItem("customer", JSON.stringify(context.state.order.customer));
    },
    clearCartData(context) {
      context.commit("setCartData", []);
      context.commit("setCustomerData", {});
      localStorage.removeItem("cart");
      localStorage.removeItem("customer");
    },
    initializeCart(context, store) {
      context.dispatch("loadCartData");
      store.watch(state => state.cart.order.lines,
          () => context.dispatch("storeCartData"), { deep: true});
    },
    initializeCustomer(context, store) {
      context.dispatch("loadCartData");
      store.watch(state => state.cart.order.customer,
          () => context.dispatch("storeCartData"), { deep: true});
    },
    search(context, term) {
      context.commit("setSearchTerm", term);
      context.commit("clearPages");
      context.dispatch("getPage", 2);
    },
  }
};
